import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer-container">
      <a
        target="_blank"
        className="footer-link"
        href="https://github.com/bansal1999/flashtype"
        rel="noreferrer"
      >
        Check out the source code here
      </a>
    </div>
  );
};

export default Footer;
